/**
 * Utility for mapping numerical stat values to visual ranks and grades.
 * Includes support for high UG (1201-2000) series and standard ranks.
 */

// Colors for the Watermark Rank
export const getRankColor = (rank) => {
  if (!rank) return 'text-slate-400/10 dark:text-slate-500/10';
  
  // Supreme Ranks (UG Series)
  if (rank.startsWith('UG')) return 'text-yellow-500/10 dark:text-yellow-400/10';
  // High Ranks (SS-S)
  if (rank.startsWith('S')) return 'text-red-500/10 dark:text-red-400/10';
  // Mid Ranks (A-B)
  if (rank.startsWith('A') || rank.startsWith('B')) return 'text-blue-500/10 dark:text-blue-400/10';
  // Low Ranks (C-D-E-F-G)
  return 'text-slate-400/10 dark:text-slate-500/10';
};

/**
 * Maps a numerical value to a rank string.
 * @param {number} val - The stat value (0-2000)
 * @returns {string} The rank grade
 */
export const getRank = (val) => {
  // High Ranks (UG Series - Distributed 1201-2000)
  if (val >= 1886) return 'UG6';
  if (val >= 1772) return 'UG5';
  if (val >= 1658) return 'UG4';
  if (val >= 1544) return 'UG3';
  if (val >= 1430) return 'UG2';
  if (val >= 1316) return 'UG1';
  if (val >= 1201) return 'UG';

  // Mid-High Ranks (S Series)
  if (val >= 1150) return 'SS+'; 
  if (val >= 1100) return 'SS';  
  if (val >= 1050) return 'S+';  
  if (val >= 1000) return 'S';   

  // Mid Ranks (A-B Series)
  if (val >= 900) return 'A+';
  if (val >= 800) return 'A';
  if (val >= 700) return 'B+';
  if (val >= 600) return 'B';

  // Low-Mid Ranks (C-D Series)
  if (val >= 500) return 'C+';
  if (val >= 400) return 'C';
  if (val >= 350) return 'D+';
  if (val >= 300) return 'D';

  // Low Ranks (E-F-G Series)
  if (val >= 250) return 'E+';
  if (val >= 200) return 'E';
  if (val >= 150) return 'F+';
  if (val >= 100) return 'F';
  if (val >= 50) return 'G+';
  return 'G';
};

// Legacy compatibility (if needed)
export const getStatGrade = getRank;
